import React, { InputHTMLAttributes, useState } from 'react';

interface InputSearchProps extends InputHTMLAttributes<HTMLInputElement> {
    onClear?: () => void;
    alwaysShowClear?: boolean;
    elementBefore?: React.ReactNode;
}

export const InputSearch = React.forwardRef<HTMLInputElement, InputSearchProps>(({
  className = '',
  onFocus,
  onBlur,
  onClear,
  alwaysShowClear = false,
  elementBefore,
  ...props
}, ref) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  return (
    <div className="relative">
        {elementBefore && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 z-10 flex items-center pointer-events-none">
            {elementBefore}
          </div>
        )}
        <input
        ref={ref}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={`
            w-full
            ${elementBefore ? 'ps-12 pe-9 py-3' : 'px-4 py-3 pe-9'}
            bg-brand-bg-3
            rounded-xl
            placeholder:text-brand-color-2
            focus:outline-none
            ${isFocused ? '' : ''}
            ${className}
        `}
        {...props}
        />
        {onClear && (alwaysShowClear || props.value !== '') && (
            <button 
              className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-transparent hover:opacity-70 focus:outline-none flex flex-col text-[20px] p-2"
              onClick={() => onClear()}
              type="button"
            >
              <i className="material-icons">cancel</i>
            </button>
        )}
    </div>
    
  );
});

InputSearch.displayName = 'InputSearch';
